<template>
  <div class="workarea row justify-content-center">
    <b-modal ref="removeConfirmation" id="removeConfirmation" title="Ta bort medlem" @ok="removeAction" @cancel="removeCancel" close-title="Nej" ok-title="Ja">
        <span>Vill du ta bort medlemmen?</span>
    </b-modal>
    <div class="col-md-8">
        <div class="row">
            <div class="col-sm-7">
                <h2>Medlemmar</h2>
            </div>
            <div class="col-sm">
                <div class="input-group">
                    <Autocomplete :options="getFriends()" v-model="username">
                        <template slot="item" scope="option">
                            <p><strong>{{ option.title }}</strong></p>
                        </template>
                    </Autocomplete>
                    <span class="input-group-btn">
                        <button @click="create({workarea, username, index})" type="button" class="btn btn-md btn-primary">Lägg till</button>
                    </span>
                </div>
            </div>
        </div>
        <table class="table table-bordered table-striped">
            <thead>
                <tr>
                    <th>Namn</th>
                    <th>Hantera</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(member, memberIndex) in workarea.members">
                    <td>{{ member.username }}</td>
                    <td>
                        <button class="btn btn-primary" v-on:click="selectForRemoval({workarea, member, index, memberIndex})" v-if="member.id !== userId">Ta bort</button>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import Autocomplete from '@/components/parts/Autocomplete'

export default {
    name: 'workarea',
    components: {
        Autocomplete
    },
    computed: {
        workarea () {
            return this.$store.getters.getActiveWorkarea
        },
        index () {
            return this.$store.state.workarea.active
        },
        members () {
            return this.$store.getters.getActiveWorkarea.members
        },
        userId () {
            return this.$store.state.authentication.user.id
        }
    },
    data () {
        return {
            username: '',
            member: null
        }
    },
    mounted () {
        this.refresh({workarea: this.workarea, index: this.index})
    },
    methods: {
        ...mapActions({
            refresh: 'workarea_members',
            remove: 'workarea_member_delete',
            create: 'workarea_member_post'
        }),
        ...mapGetters({
            getFriends: 'getFriendsList'
        }),
        selectForRemoval: function ({workarea, member, index, memberIndex}) {
            this.member = {workarea, member, index, memberIndex}
            this.$refs.removeConfirmation.show()
        },
        removeAction: function () {
            this.remove(this.member)
        },
        removeCancel: function () {
            this.member = null
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/Workarea.vue